/**
 * Application entry point.
 * Mounts the React root inside the #root element and enables StrictMode.
 */
import React from "react";
import ReactDOM from "react-dom/client";
import "react-calendar-heatmap/dist/styles.css";

import { App } from "./App";
import { ThemeProvider } from "./theme";
import "./styles/tailwind.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </React.StrictMode>,
);
